var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section-heading" },
    [
      _vm.headingType === "top"
        ? [
            _c("div", { attrs: { role: "heading", "aria-level": "3" } }, [
              _vm._v(_vm._s(_vm.section))
            ])
          ]
        : _vm.headingType === "bottom"
        ? [
            _vm._l(_vm.sectionButtons, function(sectionButton, j) {
              return [
                _c(
                  "div",
                  { key: j + "-sectionButton" },
                  [
                    _vm._v(_vm._s(j) + "\n    "),
                    sectionButton && sectionButton.status !== "Disabled"
                      ? _c("section-heading-button", {
                          attrs: {
                            section: _vm.section,
                            sectionButton: sectionButton
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            })
          ]
        : [
            _c("div", { attrs: { role: "heading", "aria-level": "3" } }, [
              _vm._v(_vm._s(_vm.section))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { display: "flex", "padding-right": "10px" } },
              [
                _vm._l(_vm.sectionButtons, function(sectionButton, j) {
                  return [
                    _c(
                      "div",
                      { key: j + "-sectionButton" },
                      [
                        sectionButton && sectionButton.status !== "Invisible"
                          ? _c("section-heading-button", {
                              attrs: {
                                section: _vm.section,
                                sectionButton: sectionButton
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                })
              ],
              2
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62c58777", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62c58777","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/presentational/SectionHeading.vue
// module id = null
// module chunks = 